const STORAGE_KEY = "vims.sales-order-from-inventory";

export function saveSalesOrderFromInventory(draft) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
}

export function readSalesOrderFromInventory() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.lines) || parsed.lines.length === 0) {
      return null;
    }

    return parsed;
  } catch (error) {
    return null;
  }
}

export function clearSalesOrderFromInventory() {
  sessionStorage.removeItem(STORAGE_KEY);
}
